export default __webpack_public_path__ + "static/media/ui.213cdb7e.png";